// Dünner, animierter Aktivitätsbalken ganz oben + kleines "läuft…"-Pill.
// Erscheint, sobald irgendein (nicht stiller) Request läuft.
import React, { useEffect, useState } from 'react';
import { installGlobalActivity, subscribeActivity, getActivityLabel } from '@/lib/globalActivity';

installGlobalActivity();

export default function GlobalActivityBar() {
  const [active, setActive] = useState(false);
  const [label, setLabel] = useState('läuft…');

  useEffect(() => {
    let hideTimer = null;
    const unsub = subscribeActivity((pending) => {
      if (pending > 0) {
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        setLabel(getActivityLabel());
        setActive(true);
      } else {
        hideTimer = setTimeout(() => setActive(false), 250);
      }
    });
    return () => { unsub(); if (hideTimer) clearTimeout(hideTimer); };
  }, []);

  return (
    <>
      <style>{`
        @keyframes sf-activity-slide {
          0% { left: -40%; width: 40%; }
          50% { left: 30%; width: 45%; }
          100% { left: 100%; width: 40%; }
        }
        @keyframes sf-activity-fade {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* Top-Balken */}
      <div
        aria-hidden={!active}
        data-testid="global-activity-bar"
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, height: '3px',
          zIndex: 9999, pointerEvents: 'none',
          opacity: active ? 1 : 0, transition: 'opacity 200ms ease',
          background: 'rgba(0,0,0,0.06)', overflow: 'hidden',
        }}
      >
        {active && (
          <div
            style={{
              position: 'absolute', top: 0, height: '100%',
              background: 'linear-gradient(90deg, rgba(234,179,8,0) 0%, #EAB308 50%, rgba(234,179,8,0) 100%)',
              animation: 'sf-activity-slide 1.1s ease-in-out infinite',
              borderRadius: '2px',
            }}
          />
        )}
      </div>

      {/* Kleines "läuft…"-Pill unten rechts */}
      {active && (
        <div
          data-testid="global-activity-pill"
          style={{
            position: 'fixed', bottom: '16px', right: '16px', zIndex: 9998,
            animation: 'sf-activity-fade 200ms ease', pointerEvents: 'none',
          }}
          className="flex items-center gap-2 rounded-full bg-black/80 text-white text-xs font-medium px-3 py-1.5 shadow-lg"
        >
          <span
            style={{
              width: '12px', height: '12px', borderRadius: '9999px',
              border: '2px solid rgba(255,255,255,0.35)', borderTopColor: '#EAB308',
              display: 'inline-block', animation: 'spin 0.8s linear infinite',
            }}
          />
          {label}
        </div>
      )}
    </>
  );
}
